import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class PaymentService {
    constructor(private http: HttpClient) { }

    getVatAmount() {
        return this.http.get(`${environment.apiUrl}/transaction/get-vat`);
    }

    getTransactionHistory(campaignId) {
        return this.http.get(`${environment.apiUrl}/transaction/get-history/${campaignId}`);
    }

    getCheckoutInfo(id) {
        return this.http.get(`${environment.apiUrl}/checkout/prepare/${id}`);
    }

    checkoutAndPublish(id, approvementPerSupplier, previewMode) {
        return this.http.post(`${environment.apiUrl}/checkout/${id}`, {
            approvementPerSupplier,
            addingVisuals: previewMode
        });
    }

    getUserWallet() {
        return this.http.get(`${environment.apiUrl}/payment/wallet`);
    }

    getCampaignCharges(campaignId: string) {
        return this.http.get(`${environment.apiUrl}/campaign/charges/get-total-per-cities/${campaignId}`);
    }

    addCampaignCharges(campaignId: string, charges: any[]) {
        return this.http.post(`${environment.apiUrl}/campaign/charges/add/${campaignId}`, charges);
    }

    calculateTotalCharges(campaignId: string, supplierId: number) {
        return this.http.get(`${environment.apiUrl}/payment/charges/total/${campaignId}/${supplierId}`);
    }

    processRefund(campaignId: string, refundRequest: any) {
        return this.http.post(`${environment.apiUrl}/payment/refund/${campaignId}`, refundRequest);
    }

    getRefundHistory(campaignId: string) {
        return this.http.get(`${environment.apiUrl}/payment/refund/history/${campaignId}`);
    }
}
